import { Color, LayerText } from '@/types/models';
import { LayerObjectAdapter } from '@/utils/layer/LayerObjectAdapter';

type VerticalAlignType = 'TOP' | 'MIDDLE' | 'BOTTOM';

type HorizontalAlignType = 'LEFT' | 'RIGHT' | 'CENTER';

export function getLayerTextAdapterId(id: number): string {
  return `txt-${id}`;
}

export class LayerTextAdapter implements LayerText, LayerObjectAdapter {
  public id: number;

  public x: number;

  public y: number;

  public z: number;

  public width: number;

  public height: number;

  public layer: number;

  public fontSize: number;

  public notes: string;

  public verticalAlign: VerticalAlignType;

  public horizontalAlign: HorizontalAlignType;

  public backgroundColor: Color;

  public borderColor: Color;

  public color: Color;

  public borderThickness: number;

  constructor(layerText: LayerText) {
    this.id = layerText.id;
    this.x = layerText.x;
    this.y = layerText.y;
    this.z = layerText.z;
    this.width = layerText.width;
    this.height = layerText.height;
    this.layer = layerText.layer;
    this.fontSize = layerText.fontSize;
    this.notes = layerText.notes;
    this.verticalAlign = layerText.verticalAlign;
    this.horizontalAlign = layerText.horizontalAlign;
    this.backgroundColor = layerText.backgroundColor;
    this.borderColor = layerText.borderColor;
    this.color = layerText.color;
    this.borderThickness = layerText.borderThickness;
  }

  public getId(): string {
    return getLayerTextAdapterId(this.id);
  }

  public getOriginalId(): number {
    return this.id;
  }
}
